// @ts-nocheck
import React from 'react';
import KwPanel from '../../../common/KwPanel';
import FormStatic from '../../../common/FormStatic';
import Loading from '../../../common/Loading';
import { TryFormatJson } from '../../../../util/formatter';
import FormattedDate from '../../../../components/common/FormattedDate';
import YesNoLabel from '../../../common/YesNoLabel';
import { useTranslation } from 'react-i18next';

const EmailForm = ({ email }) => {
  const { t } = useTranslation();
  return email ? (
    <KwPanel className="pb-2">
      <FormStatic label={t('To address')}>{email.toAddress}</FormStatic>
      {email.ccAddress && (
        <FormStatic label={t('Cc address')}>{email.ccAddress}</FormStatic>
      )}
      {email.bccAddress && (
        <FormStatic label={t('Bcc address')}>{email.bccAddress}</FormStatic>
      )}
      <FormStatic label={t('Subject')}>{email.subject}</FormStatic>
      <FormStatic label={t('Email template')}>{email.viewName}</FormStatic>
      <FormStatic label={t('Data')}>
        <div className="num" style={{ whiteSpace: 'pre', overflowX: 'auto' }}>
          {TryFormatJson(email.templateData)}
        </div>
      </FormStatic>
      <FormStatic label={t('Success')}>
        <YesNoLabel value={email.success} />
      </FormStatic>
      {email.lastError && (
        <FormStatic label={t('Error')}>
          <div className="num" style={{ whiteSpace: 'pre', overflowX: 'auto' }}>
            {email.lastError}
          </div>
        </FormStatic>
      )}
      <FormStatic label={t('Last send time')}>
        <FormattedDate value={email.lastSendTime} variant="noHtml" />
      </FormStatic>
      <FormStatic label={t('Retry count')}>{email.retryCount}</FormStatic>
      <FormStatic label={t('Next send time')}>
        <FormattedDate value={email.nextSendTime} variant="noHtml" />
      </FormStatic>
      <FormStatic label={t('Expire time')}>
        <FormattedDate value={email.expireDateTime} variant="noHtml" />
      </FormStatic>
    </KwPanel>
  ) : (
    <Loading></Loading>
  );
};



export default EmailForm;
